import React from 'react';
import { useRecoilState } from 'recoil';
import { Label } from '@nooz-optics/nooz-components-lib';
import { Button } from '../../Elements';
import { sidebarState } from '../../../../utils/recoil/sidebar';
import {
  LanguageSettingsSwitcher,
  CurrencySettingsSwitcher,
} from '../Header/Banner/LanguageCurrencySwitch';
import { withLocale } from '../../../../utils/hocs';
import { returnCurrentZone } from '../../../../utils/globals';
import { useDrawer } from '../../../../utils/recoil/drawer';

export const LanguageCurrencySwitch = withLocale(
  ({ label, language, currency, locale, isWhite }) => {
    const drawer = useDrawer();

    const color = isWhite ? { classname: 'white' } : { classname: 'primary' };

    const currentLanguage = language?.values.filter(
      (val) => val.value === locale[0]
    )[0];

    const onLanguageSettingClick = () => {
      drawer.open({
        placement: 'left',
        width: 'w-96',
        title: null,
        body: <LanguageSettingsSwitcher {...language} />,
        footer: null,
        backdropLink: null,
      });
    };

    const onCurrencySettingClick = () => {
      drawer.open({
        placement: 'left',
        width: 'w-96',
        title: null,
        body: <CurrencySettingsSwitcher {...currency} />,
        footer: null,
        backdropLink: null,
      });
    };

    return (
      <>
        <Label
          {...label}
          type='h3'
          size='2xl'
          weight='bold'
          color={color}
        />
        <div className='mt-4 sm:max-w-xs'>
          <div className='my-2'>
            <div className='mb-1'>
              <Label
                {...language?.label}
                color={color}
              />
            </div>
            <Button
              label={{
                ...language?.label,
                text: currentLanguage?.label?.text,
              }}
              icon={{ iconKey: 'HiChevronRight' }}
              color={color}
              size='base'
              type='outlined'
              onClick={onLanguageSettingClick}
            />
          </div>
          <div className='my-1'>
            <div className='mb-1'>
              <Label
                {...currency?.label}
                color={color}
              />
            </div>
            <Button
              label={{
                ...currency?.label,
                text: returnCurrentZone(currency.values)?.label?.text,
              }}
              icon={{ iconKey: 'HiChevronRight' }}
              color={color}
              size='base'
              type='outlined'
              onClick={onCurrencySettingClick}
            />
          </div>
        </div>
      </>
    );
  }
);
